import { Link } from 'react-router-dom';
import { GLOBAL_ERROR_BOUNDARY_MESSAGE } from '../../util/constants';

const ErrorBoundaryMessage = props => {
  const { resetErrorBoundary } = props;
  const region_URL = process.env.REACT_APP_URL_REG_ALL;
  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <p className='motif-subtitle-default-regular' style={{ textAlign: 'center' }}>
        {GLOBAL_ERROR_BOUNDARY_MESSAGE.title}
      </p>
      <p className='motif-body1-default-light'>
        {GLOBAL_ERROR_BOUNDARY_MESSAGE.description}
      </p>
      <p>
        <Link
          to={region_URL}
          onClick={resetErrorBoundary}
        >Go Back to Home</Link>
      </p>
      {/* <Button className={'error-boundary-reset-btn'}  onClick={resetErrorBoundary}>Reload</Button> */}
    </div>
  );
};

export default ErrorBoundaryMessage;
